interface BottomArrowProps {
  collapsed: boolean;
}
const BottomArrow: React.FC<BottomArrowProps> = ({ collapsed }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      className={`u-transition-transform ${collapsed ? "u-rotate-0" : "u-rotate-180"}`}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5077"
            data-name="Rectangle 5077"
            width="10"
            height="10"
            transform="translate(0 0)"
            fill="#636363"
          />
        </clipPath>
      </defs>
      <g id="Mask_Group_570" data-name="Mask Group 570" clipPath="url(#clip-path)">
        <g id="next_1_" data-name="next (1)" transform="translate(9.69 2.462) rotate(90)">
          <g id="Group_18066" data-name="Group 18066" transform="translate(0 0)">
            <path
              id="Path_59444"
              data-name="Path 59444"
              d="M4.937,4.413.618.106A.362.362,0,1,0,.107.618L4.168,4.669.106,8.719a.362.362,0,0,0,.511.512L4.937,4.925a.362.362,0,0,0,0-.512Z"
              fill="#636363"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BottomArrow;
